<template>
    <div>
        <LoadingVue :isLoading="isLoading" :key="isLoading"/>
        
        <div :class="view_class_view.div_container" class="grid grid-cols-1">
            <div class="my-2">
                <label for="input_payment_method">Método de Pago:</label>
                <select type="text" id="input_payment_method" name="input_payment_method" v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: collectionModelValidations.payment_method.$error, [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!collectionModelValidations.payment_method.$invalid, [view_class_view.class_inputs.default ]: collectionModelValidations.payment_method.$invalid && !collectionModelValidations.payment_method.$error }" class="w-full py-2 px-2 rounded-md border-2 border-sm mb-2 mt-2 shadow-md focus:outline-none" v-model="collectionModel.payment_method" @blur="collectionModelValidations.payment_method.$validate">
                    <option v-for="(method, i) in payment_methods" :key="i" :value="method.value">{{ method.text }}</option>
                </select>
                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of collectionModelValidations.payment_method.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>

            <div class="my-2">
                <label for="input_payment_frecuency">Frecuencia de pago:</label>
                <select type="text" id="input_payment_frecuency" name="input_payment_frecuency" v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: collectionModelValidations.payment_frequency.$error, [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!collectionModelValidations.payment_frequency.$invalid, [view_class_view.class_inputs.default ]: collectionModelValidations.payment_frequency.$invalid && !collectionModelValidations.payment_frequency.$error }" class="w-full py-2 px-2 rounded-md border-2 border-sm mb-2 mt-2 shadow-md focus:outline-none" v-model="collectionModel.payment_frequency" @blur="collectionModelValidations.payment_frequency.$validate">
                    <option v-for="(frequency, i) in payment_frequencies" :key="i" :value="frequency.value">{{ frequency.text }}</option>
                </select>
                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of collectionModelValidations.payment_frequency.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import LoadingVue from '../VueLoading.vue';
import { helpers, requiredIf } from "@vuelidate/validators";

export default {
    name: 'IssuanceCollection',
    props: {
        payment_methods: {
            type: Array,
            required: true,
            default(){
                return [{value: 'tarjeta de crédito', text: 'Tarjeta de crédito'}, {value: 'tarjeta de débito', text: 'tarjeta de débito'}, {value: 'transferencia bancaria', text: 'transferencia bancaria'}, {value: 'descuento por nomina', text: 'Descuento por nomina'}];
            }
        },
        payment_frequencies: {
            type: Array,
            required: true,
            default(){
                return [{value: 'mensual', text: 'Mensual'}];
            }
        },
        view_class_view: {
            type: Object,
            required: true,
            default(){
                return {
                    class_inputs:{
                        valid:"border-blue-600",
                        no_valid:"border-red-600",
                        default:"w-full py-2 px-2 rounded-md border-2 border-sm focus:border-blue-600 mb-2 mt-2 shadow-md focus:outline-none "
                    },
                    div_container_error:{
                        container:"my-2",
                        text_error:"text-red-600",
                    },
                    div_container:"grid grid-cols-1 sm:grid-cols-3 sm:gap-10",
                }
            }
        },
        validations: {
            type: Object,
            required: true,
            default() {
                return {
                    payment_method: {
                        required: helpers.withMessage('El campo es requerido', requiredIf(true))
                    },
                    payment_frequency: {
                        required: helpers.withMessage('El campo es requerido', requiredIf(true))
                    }
                };
            }
        }
    },
    setup(props) {

        let isLoading = ref(false);
        let collectionModel = ref({
            payment_method: "",
            payment_frequency: ""
        });

        const collectionModelValidations = useVuelidate(props.validations, collectionModel);
       
        function execute_validation() {
            collectionModelValidations.value.$validate();
            if(collectionModelValidations.value.$error)return null;
            return collectionModel.value;
        }

        return {
            isLoading,
            collectionModel,
            collectionModelValidations,
            execute_validation
        }
    },
    components: {
        LoadingVue
    }
}

</script>